import { render } from "./ClientsList.vue?vue&type=template&id=4dae3991&scoped=true&xmlns%3Av-expand-transition=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"

import "./ClientsList.vue?vue&type=style&index=0&id=4dae3991&scoped=true&lang=css"
import "./ClientsList.vue?vue&type=style&index=1&id=4dae3991&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dae3991"]])

export default __exports__